/**
 * @param e blur event
 * @param onContainerBlur вызывается при выходе фокуса за пределы контейнера
 */
export const handleContainerBlur = (
  e: React.FocusEvent<Element>,
  onContainerBlur: () => void,
) => {
  const { currentTarget, relatedTarget } = e;
  if (currentTarget.contains(relatedTarget)) return;

  onContainerBlur();
};
